<template>
  <!--供应商订单详情 -->
  <div class="orderdetail">
    <cube-page type="orderdetail-view" title="订单详情">
      <div slot="content">
        <div class="orderitem">
          <div class="ordertitle">
            <p>订单号：{{order.order_no}}</p>
            <p class="colorred">{{order.order_status_text}}</p>
          </div>
          <div class="ordemain">
            <div class="ordecontent">
              <div class="order">
                <van-image radius="8" width="88" height="90" :src="order.image"/>
                <div class="orderright">
                  <p class="ordername ells">{{order.goods_name}}</p>
                  <div class="carddesc">
                    <span>使用时间：</span>
                    <span>{{order.use_date}}</span>
                  </div>
<!--                  <div class="carddesc">
                    <span>支付金额：</span>
                    <span>{{order.pay_price}}</span>
                  </div>-->
                  <div class="carddesc">
                    <span>下单时间：</span>
                    <span>{{order.createtime}}</span>
                  </div>
                </div>
              </div>
              <div style="width: 80px; height: 80px;">
                <van-image
                  v-show="order.master_write_code != '' && order.order_status_text !='已退单' && !order.code_hide"
                  @click="imgShow(order.master_write_code)"
                  width="80"
                  height="80"
                  :src="order.master_write_code"
                />
              </div>
            </div>
            <div class="orderfooter">
              <p class="ordernum">
                <span>下单数量：</span>
                {{order.total_num}}
              </p>
              <div class="orderjj"></div>
            </div>
          </div>
        </div>
        <div class="td-flex">
          <van-button
            v-if="order.save_date==1"
            type="danger"
            size="mini"
            round
            plain
            @click="omDateShow(order.use_date)"
          >时间更改</van-button>
          <van-button
            v-if="order.refund==1"
            type="danger"
            size="mini"
            round
            plain
            @click="handerPlTd"
          >{{ isPl ? '取消批量' : '批量退款' }}</van-button>
        </div>
        <van-collapse v-model="activeNames">
          <van-collapse-item title="备注信息">
            <div class="itembox">
              <div class="itemright">
                <div class="itemxx" v-if="order.code_hide">
                  <span style="color: red">{{order.code_hide_msg}}</span>
                </div>
                <div class="itemxx" v-if="remarks.user">
                  用户备注：
                  <span>{{remarks.user}}</span>
                </div>
                <div class="itemxx" v-if="remarks.dtb">
                  分销商备注：
                  <span>{{remarks.dtb}}</span>
                </div>
                <div class="itemxx" v-if="remarks.spl">
                  供应商备注：
                  <span>{{remarks.spl}}</span>
                </div>
                <div class="itemxx" v-if="remarks.refusal">
                  拒单备注：
                  <span>{{remarks.refusal}}</span>
                </div>
              </div>
            </div>
          </van-collapse-item>
          <div  v-for="(goods,index) in list" :key="index">
            <van-collapse-item :title="goods.goods_attr" >
            <van-checkbox-group v-model="result" ref="checkboxGroup" @change="checksChange">
              <div class="itembox" v-for="(item,index) in goods.meta" :key="index">
                <van-checkbox
                  v-if="isPl"
                  style="padding-right:10px;"
                  :name="item.id"
                  :disabled="item.use_status == '40' || item.use_status == '39' || item.use_status == '38'"
                  checked-color="#ee0a24"
                ></van-checkbox>
                <div class="itemright">
                  <div class="itemxx">
                    联系人：
                    <span>{{item.contacts}}</span>
                  </div>
                  <div class="itemxx">
                    手机号：
                    <span class="phpne" @click="goPhone(item.telephone)">
                      {{item.telephone}}
                      <van-icon name="phone-o"/>
                    </span>
                  </div>
                  <div class="itemxx" v-if="item.IDCard">
                    证件号：
                    <span>{{item.IDCard}}</span>
                  </div>
                  <div class="itemxx" v-if="item.code">
                    核销码：
                    <span>{{item.code}}</span>
                  </div>
                  <div class="itemxx" v-if="item.code">
                    核销状态：
                    <span>{{item.use_status_text}}</span>
                  </div>
                  <div class="itemxx" v-if="item.use_num">
                    核销次数：
                    <span>{{item.use_num}}</span>
                  </div>
                  <div class="itemxx" v-if="item.last_use_time">
                    核销时间：
                    <span>{{item.last_use_time}}</span>
                  </div>
                  <div style="color: red" class="itemxx" v-if="item.travel_text.length > 0" v-for="(value,i) in item.travel_text">
                    <div>行程-{{i+1}}</div>
                    <div v-for="(text,i) in value">
                      {{text.label}}：{{text.value}}
                    </div>
                  </div>
                </div>
                <div class="itembtns" v-if="item.code && item.use_status=='10'">
                  <van-button
                    icon="qr"
                    size="small"
                    round
                    type="info"
                    plain
                    @click="showQr(item)"
                  >核销码</van-button>
                </div>
              </div>
            </van-checkbox-group>
          </van-collapse-item>
          </div>
        </van-collapse>
        <div class="fid-fo" v-if="isPl">
          <div class="footer-btns">
            <van-checkbox v-model="checkedall" @click="checkAll" checked-color="#ee0a24">全选</van-checkbox>
            <van-button
              @click="tdshow=true"
              type="danger"
              round
              :disabled="result.length == 0"
              size="small"
            >确认退款</van-button>
          </div>
        </div>
      </div>
    </cube-page>
    <van-calendar v-model="dateShow" @confirm="onConfirmDate" :default-date="defaultDate"/>
    <van-popup v-model="txshow" round>
      <div class="qrshow">
        <div class="titlebox">
          <p class="title">修改价格</p>
          <p class="right" @click="txshow=false">
            <van-icon name="close"/>
          </p>
        </div>
        <van-form @submit="onSubmitTx">
          <!-- 允许输入正整数，调起纯数字键盘 -->
          <van-field
            v-model="xgprice"
            name="number"
            type="number"
            label="修改价格￥"
            :colon="true"
            placeholder="请输入修改价格"
          />
          <div style="margin: 16px;">
            <van-button round block type="info" native-type="submit">提交</van-button>
          </div>
        </van-form>
      </div>
    </van-popup>
    <van-popup v-model="qrshow" round class="qrpopup" style="width: 80%;padding: 40px 0;">
      <div class="qrshow">
        <div class="imgcenter">
          <van-image :src="resData.code_url" alt="二维码"/>
        </div>
        <p class="pm">
          <span>{{resData.code}}</span>
        </p>
      </div>
    </van-popup>
    <van-dialog
      v-model="tdshow"
      title="确认退款"
      show-cancel-button
      @cancel="tdcalcel"
      @confirm="tdConFirm"
    >
      <van-field
        v-model="tdvalue"
        rows="1"
        autosize
        maxlength="25"
        show-word-limit
        :clearable="true"
        type="textarea"
        placeholder="请输入退款原因"
        style="align-items:center;"
      />
    </van-dialog>
  </div>
</template>

<script>
import CubePage from "../../TP/cube-page.vue";
import * as util from "@/utils/network";
import { Dialog,Toast, ImagePreview } from "vant";

export default {
  components: {
    CubePage
  },
  data() {
    return {
      store: null,
      activeNames: ["1", "2"],
      active: 0,
      txshow: false,
      xgprice: "",
      id: this.$route.query.id,
      isUpdate: this.$route.query.update,
      isShop: this.$route.query.isshop,
      isnoShow: this.$route.query.noShow ? "1" : null,
      list: {},
      order: {},
      remarks: {},
      goods: {},
      detail: {
        address: {
          Area: {}
        }
      },
      disabled: false,
      gcfg: [],
      qrshow: false,
      resData: {},
      isPl: false,
      result: [],
      checkedall: false,
      tdshow: false,
      tdvalue: "",
      dateShow: false,
      defaultDate:null
    };
  },
  created() {
    this.gcfg = this.$store.getters.getGcfg;
    this.store = this.$store.getters.getShop;
    this.getData();
  },
  methods: {
    //打开时间弹框
    omDateShow(dd){
      console.log(dd)
        this.defaultDate=new Date(dd);
        this.dateShow=true;
    },
    formatDate(date) {
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    },
    //确认退单
    tdConFirm() {
      let that = this;
      var url = "/addons/litestore/api.supplier/refund";
      var ids = [];
      let param = {
        order_id: that.order.id,
        uid: that.order.user_id,
        ids: that.result,
        remarks:that.tdvalue
      };
      //这里直接调用网络接口
      util.post(url, param, function(result) {
        if (result.code == 1) {
          console.log(result.msg);
          that.$toast.success({
            message: result.msg,
            duration: 800,
            onClose: function() {
              location.reload();
            }
          });
        }
      });
    },
    //取消按钮
    tdcalcel() {
      this.tdvalue = "";
      this.tdshow = false;
    },
    //打开全选
    handerPlTd() {
      let that = this;
      that.isPl = !that.isPl;
      that.result = [];
      that.checkedall = false;
    },
    //更改出行时间
    onConfirmDate(date) {
      let that = this;
      Dialog.confirm({
        title: "温馨提示",
        message: "确认更改出行时间吗"
      })
        .then(() => {
          // on confirm
          var chanageDate = that.formatDate(date);
          console.log(chanageDate);
          var url = "/addons/litestore/api.supplier/saveUseDate";
          //这里直接调用网络接口
          util.post(
            url,
            {
              id: that.order.id,
              uid: that.order.user_id,
              use_date: chanageDate
            },
            function(result) {
              that.dateShow=false
              that.defaultDate=null
              if (result.code == 1) {

                that.$toast.success({
                  message: result.msg,
                  duration: 800,
                  onClose: function() {
                    location.reload();
                  }
                });

              }else{
                Toast.fail(result.msg)
              }
            }
          );
        })
        .catch(() => {
          // on cancel
          that.defaultDate=null
          that.dateShow=false
        });
    },
    checksChange() {
      let that = this;
      let total = that.getSelectableCount();
      that.checkedall = total > 0 && that.result.length == total;
    },
    //统计可选(非禁用)项总数，兼容单goods对象与多goods数组两种结构
    getSelectableCount() {
      let that = this;
      let count = 0;
      let arr = Array.isArray(that.list) ? that.list : (that.list ? [that.list] : []);
      arr.forEach(function(goods) {
        if (goods && goods.meta) {
          goods.meta.forEach(function(item) {
            if (!(item.use_status == '40' || item.use_status == '39' || item.use_status == '38')) {
              count++;
            }
          });
        }
      });
      return count;
    },
    checkAll() {
      let that = this;
      let total = that.getSelectableCount();
      //以当前已选数对比可选总数决定方向，不依赖@click时checkedall的旧值
      let shouldSelect = that.result.length < total;
      that.checkedall = shouldSelect;
      let groups = that.$refs.checkboxGroup;
      //checkboxGroup在v-for内是数组，需逐个分组调用
      if (!Array.isArray(groups)) {
        groups = groups ? [groups] : [];
      }
      groups.forEach(function(group) {
        group.toggleAll({
          checked: shouldSelect,
          skipDisabled: true
        });
      });
    },
    //拨打电话
    goPhone(e) {
      window.location.href = "tel://" + e;
    },
    imgShow(url) {
      ImagePreview([url]);
    },
    //获取核销码
    showQr(item) {
      let that = this;
      var url = "/addons/litestore/api.order/order_wirteoffcode";
      //这里直接调用网络接口
      util.post(
        url,
        {
          order_id: that.list.id,
          id: item.id
        },
        function(res) {
          that.resData = res.data;
          that.qrshow = true;
        }
      );
    },
    onTxshow() {
      this.txshow = true;
      this.xgprice = this.list.pay_price;
    },
    // 价格修改
    onSubmitTx() {
      var url = "/addons/litestore/api.account/editPayPrice";
      let that = this;
      //这里直接调用网络接口
      util.post(
        url,
        {
          store_id: that.store.id,
          id: that.id,
          amount: that.xgprice
        },
        function(result) {
          Toast.success(result.msg);
          that.txshow = false;
        }
      );
    },
    getData() {
      let that = this;
      var url = "/addons/litestore/api.order/detail";
      console.log(that.isUpdate);
      var parm = {
        id: that.id,
        metaIds: this.$route.query.metaIds,
        type: 2,
        goBack: "true"
      };
      if (that.isShop != undefined) {
        //util.isToken
        parm = {
          store_id: that.store.id,
          id: that.id
        };
      }
      //这里直接调用网络接口
      util.get(
        url,
        parm,
        function(result) {
          console.log(result);
          that.order = result.data;
          that.remarks = result.data.remarks;
          that.list = result.data.goods;
          that.xgprice = result.data.pay_price;
        },
        function(err) {
          console.log(err);
        }
      );
    },
    decimalPoint(val) {
      const splitPrice = (val || "0.00").split(".");
      const numb1 = splitPrice[0];
      var numb2 = "00";
      if (splitPrice.length > 1) {
        numb2 = splitPrice[1];
      }
      return `${numb1}.<span style="font-size: 12px; line-height: 12px;">${numb2}</span>`;
    }
  },
  watch: {
    "$store.state.gcfg"() {
      this.gcfg = this.$store.getters.getGcfg;
    },
    "$store.state.shop"() {
      this.store = this.$store.getters.getShop;
    }
  }
};
</script>
<style lang="less" scoped="scoped">
@import url("../../../assets/css/order.css");
@import url("../../../assets/css/listboxless.less");

.ordemain {
  padding: 15px;

  .orderfooter {
    height: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;

    .ordernum {
    }

    .orderjj {
      display: flex;
    }

    .item {
      padding-left: 15px;
      color: #aaabaf;

      .price {
        font-size: 15px;
        font-weight: 600;
      }
    }

    .blodspan {
      color: #000;
      font-weight: 600;
    }
  }
}

.ordecontent {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .order {
    flex: 1;
    width: 0;
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .orderright {
      flex: 1;
      width: 0;
      flex-shrink: 0;
      padding: 0 10px;

      .ordername {
        font-size: 14px;
      }

      .orderdec {
        padding: 5px 0;
        font-size: 13px;
      }

      .carddesc {
        font-size: 12px;
      }

      .orderp {
        height: 28px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .ordernum {
          font-size: 12px;
          color: #969799;
        }

        .dj {
          span {
            font-size: 12px;
          }
        }
      }
    }
  }
}

.van-cell {
  background-color: #ffffff;
}

.van-collapse {
  padding-bottom: 80px;
}

.itembox {
  display: flex;
  align-items: center;
  padding: 5px 0;

  .itemleft {
    width: 60px;
  }

  .itemright {
    flex: 1;

    .itemxx {
      line-height: 25px;
    }
  }

  .itembtns {
    width: 78px;
  }
}

.itembox + .itembox {
  border-top: 1px solid #e5e5e5;
}
.td-flex {
  padding: 0 16px;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
  .itemxx {
    line-height: 25px;
    color: #969799;
    font-size: 14px;
    span {
      color: #000;
    }
  }
}
.fid-fo {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}

.footer-btns {
  box-shadow: 3px 5px 8px #787878;
  padding: 0 15px;
  height: 60px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
